import { render, staticRenderFns } from "./EmSppStorageInfoStiList.vue?vue&type=template&id=8dcd0a98&"
import script from "./EmSppStorageInfoStiList.vue?vue&type=script&lang=js&"
export * from "./EmSppStorageInfoStiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports